module.exports = __webpack_public_path__ + "img/40.6162f4b3.jpg";